import { FC } from "react";
import i18next from "i18next";
import useDocumentTitle from "@/hooks/useDocumentTitle";
import { CoverImage } from "@/components";
import Image from "@/assets/cover/news_dbg.webp";
import FeedbackForm from "@/features/feedback/components/FeedbackForm/FeedbackForm";

const FeedbackPage: FC = (): JSX.Element => {
  useDocumentTitle("Feedback");

  return (
    <>
      <CoverImage
        src={Image}
        alt="CoverImage"
        heading={i18next.t("feedback.heading")}
        desc={i18next.t("feedback.desc")}
      />
      <FeedbackForm />
    </>
  );
};

export default FeedbackPage;
